import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../shared/baseUrl";

function TaraweehList() {
  const [taraweehData, settaraweehData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetch(baseUrl + "api/v1/taraweeh")
      .then((res) => res.json())
      .then((data) => settaraweehData(Array.isArray(data) ? data : []))
      .catch(() => settaraweehData([]));
  }, []);

  const filteredTaraweeh = taraweehData.filter((taraweh) =>
    `${taraweh.title} ${taraweh.city} ${taraweh.year}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase()),
  );

  return (
    <>
      <div className="search-input">
        <input
          type="text"
          placeholder="Search taraweeh..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="reciters-grid">
        {filteredTaraweeh.map((taraweeh) => (
          <button
            key={taraweeh.id}
            className="reciter-card"
            onClick={() => navigate(`/taraweeh/${taraweeh.slug}`)}
          >
            <img
              src={`${baseUrl}storage/${taraweeh.image}`}
              alt={taraweeh.title}
            />
            <div className="taraweeh-info">
              <h3 className="title">
                {taraweeh.city} {taraweeh.title}
              </h3>
              <h3 className="riwaya">{taraweeh.year}</h3>
            </div>
          </button>
        ))}
      </div>
    </>
  );
}

export default TaraweehList;
